import currencyFormatter from 'currency-formatter';
import { Typography } from 'material-ui';
import { withStyles } from 'material-ui/styles';
import React from 'react';
import { translate } from 'react-i18next';
import { getNetAndPvp } from '../Utils/shared';

const styles = theme => ({
    price: {
        marginTop: '0px',
        marginBottom: '4px',
        fontWeight: 700,
        fontSize: '1.5em',
        color: 'var(--error-color)',
        textAlign: 'right'
    },
    pvpPrice: {
        display: 'block',
        fontSize: '0.75rem',
        fontWeight: 600,
        color: '#555',
        lineHeight: 1.3,
        marginTop: 2,
        textTransform: 'uppercase',
        letterSpacing: '0.03em',
        whiteSpace: 'nowrap'
    }
});

class PriceTag extends React.Component {


    formatPrice(value) {
        return currencyFormatter.format(value, { code: 'EUR' });
    }

    shouldShowRetailPrice() {
        const { B2bVerPVP, pvp, price } = this.props;
        if (B2bVerPVP) {
            return false;
        }
        return getNetAndPvp(price, pvp).showPvp;
    }


    render() {
        const { B2bVerPVP, pvp, price, showNetPrice, classes, t } = this.props;
        const ordered = getNetAndPvp(price, pvp);
        let priceTooltip = '';

        if (showNetPrice) {
            priceTooltip = t('BOOKINGS.NET') + ': ' + this.formatPrice(ordered.net);
        }

        const displayedPrice = B2bVerPVP ? ordered.pvp : ordered.net;
        const showRetailPrice = this.shouldShowRetailPrice();

        return (
            <Typography className={classes.price}>
                <span title={priceTooltip}>
                    {this.formatPrice(displayedPrice)}
                </span>
                {showRetailPrice ? (
                    <small className={'cmsPvpPrice ' + classes.pvpPrice}>
                        PVP: {this.formatPrice(ordered.pvp)}
                    </small>
                ) : null}
            </Typography>
        );
    }
}

export default translate('translations')(withStyles(styles)(PriceTag));



// WEBPACK FOOTER //
// ./src/components/Results/PriceTag.js